import * as React from "react";
import * as ReactDOM from "react-dom";
import { ReactifySearchLiquidFactory, Sensors, SortBy, CustomComponent } from "@usereactify/search";
import { AppProvider } from '../context/AppContext';

import { Results } from "./Results/results";
import Filters from "./components/Filters//filters"
import { resolveReactifyMarketId } from "../utils/reactifyOverride";

if (window.location.pathname.startsWith("/search")) {
  const ReactifySearchFactory = new ReactifySearchLiquidFactory({
    mode: "search",
    market: resolveReactifyMarketId(),
    includeFields: ["*"],
    excludeFields: [],
    shopifyPermanentDomain: "bassike.myshopify.com",
    additionalComponentIds: ["SearchProductFilter"],
  });
  const ReactifySearchProvider = ReactifySearchFactory.getProvider();
  const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();

  ReactDOM.render(
    <React.StrictMode>
      <ReactifySearchProvider>
        <AppProvider>
          <Sensors />
          <CustomComponent
            componentId="SearchProductFilter"
            customQuery={() => {
              const query = {
                bool: {
                  must: [
                    { match: { published: true } }
                  ],
                  must_not: [
                    { term: { tags: "hidden" } }
                  ]
                }
              };
              return { query };
            }}
          />
          <SortBy />
          <Filters searchPage />
          <Results />
        </AppProvider>
      </ReactifySearchProvider>
    </React.StrictMode>,
    ReactifySearchMountNode
  );
}
